import { createErrorHandbook, type ErrorsHandbook, ErrorsHandbookBuilder } from '@/6_shared/api'

export const venueErrorsHandbook: ErrorsHandbook = createErrorHandbook({
  ...new ErrorsHandbookBuilder(404).build(),
  ...new ErrorsHandbookBuilder(500).build()
})
